import numeral from 'numeral';
export default function shortenNumber(value, precision = 1, roundingFunction) {
    const format = `0.[${'0'.repeat(precision)}]a`;
    return numeral(value || 0).format(format, roundingFunction).toUpperCase();
}
